<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav" :style="{height:Height+'px'}">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/index/logo@2x.png" class="headerlogo paddin100 Logoimg" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper paddin100">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <!-- 登录 -->
      <div class="textCenter postaA">

        <p class="textCenter color16448F">
          <i class="el-icon-phone"></i>&nbsp;&nbsp;(023)- 6756 1692
        </p>
        <span class="loginsussecc" @click="login">登录</span>

      </div>
    <div class="color16448F postIP"  >
      <p>Copyright&nbsp;&nbsp;2020-2022 重庆佰数科技有限公司</p>
      <p><a href="https://beian.miit.gov.cn/" target="blank" style="color:#16448F">渝ICP备2021001438号</a></p>

    </div>

              <!-- <p class="colrFFF" style="margin:12% 2% 0 0;text-align:right;font-size:12px">Copyright&nbsp;&nbsp;2020-2022 重庆佰数科技有限公司&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="blank" style="color:#fff">渝ICP备2021001438号</a></p> -->

    </div>
    <!-- 手机导航 -->
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      Height: "",
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "佰企e数",
          path: "/",
          children: []
        },
        {
          name: "功能介绍",
          path: "/software",
          children: []
        },
        {
          name: "覆盖范围",
          path: "/service",
          children: []
        },
        {
          name: "合作伙伴",
          path: "/newsinformation",
          children: []
        },
        {
          name: "企业简介",
          path: "/companyintroduction",
          children: []
        }
      ]
    };
  },
  mounted() {
    this.initHeight();
  },
  created() {},
  methods: {
    initHeight() {
      this.Height = document.documentElement.clientHeight;
      console.log(this.Height, "initHeight");
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    login() {
      window.open("https://t.besodata.com");
    }
  }
};
</script>
<style scoped>
.Logoimg {
  border-bottom: 1px solid #e3e3e3;
}
.headerlogo {
  width: 176px;
  height: 100%;
  margin: auto;
}
ul li {
  text-align: center;
  line-height: 60px;
  font-size: 18px;
}
/* 顶部 */
#header {
  /* background: #f4f4f4; */
  /* transition: all ease 0.6s; */
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #cfcfd6;
  font-size: 18px;
  /* font-weight: bold; */
  padding: 15px 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #16448f;
  text-decoration: none;
  font-weight: 700;
  /* border-bottom: 2px solid #1e73be; */
}
.loginsussecc {
  width: 130px;
  height: 40px;
  color: #fff;
  display: block;
  background-color: #16448f;
  border-radius: 2px;
  margin: auto;
  text-align: center;
  padding: 10px 0;
}
.loginsussecc:hover {
  cursor: pointer;
}
.heightnav {
  /* min-height: 950px; */
  /* height: calc(100% - 50px); */
}
.postaA {
  /* position: absolute;
  top: 80%;
  left: 5%; */

    margin:50% auto 0;
    text-align: center;
    
}

.postIP{
    margin-top: 10%;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue